// 商品类型选项
export const ITEM_TYPE_OPTIONS = [
  { value: '', label: 'common.all' },
  { value: 'location+facing', label: 'itemMasterData.itemType.location+facing' },
  { value: 'location only', label: 'itemMasterData.itemType.location only' },
  { value: 'storage only', label: 'itemMasterData.itemType.storage only' },
];

// 状态选项
export const STATUS_OPTIONS = [
  { value: '', label: 'common.all' },
  { value: 'Active', label: 'itemMasterData.status.Active' },
  { value: 'OBSOLETE', label: 'itemMasterData.status.Obsolete' },
];

// 展示类型选项
export const DISPLAY_TYPE_OPTIONS = [
  { value: '', label: 'common.all' },
  { value: 'PDQ', label: 'itemMasterData.displayType.PDQ' },
  { value: 'MU', label: 'itemMasterData.displayType.uom' },
];

// 库存单位选项
export const STOCK_UNIT_OPTIONS = [
  { value: '', label: '全部' },
  { value: 'PCS', label: 'PCS' },
  { value: 'KG', label: 'KG' },
  { value: 'L', label: 'L' },
  { value: 'BOX', label: 'BOX' },
  { value: 'PACK', label: 'PACK' },
  { value: 'CASE', label: 'CASE' },
];

// 布尔值选项（用于战略标识、新品标识、自有品牌标识）
export const BOOLEAN_OPTIONS = [
  { value: '', label: 'common.all' },
  { value: true, label: 'common.yes' },
  { value: false, label: 'common.no' },
];

// 分页大小选项
export const PAGE_SIZE_OPTIONS = [
  { value: 10, label: 'common.pageSize.10' },
  { value: 20, label: 'common.pageSize.20' },
  { value: 50, label: 'common.pageSize.50' },
  { value: 100, label: 'common.pageSize.100' },
];

// 默认分页配置
export const DEFAULT_PAGINATION = {
  currentPage: 1,
  pageSize: 20,
  showSizeChanger: true,
  showQuickJumper: true,
  pageSizeOptions: ['10', '20', '50', '100'],
  showTotal: (total: number, range: number[]) => 
    `显示 ${range[0]}-${range[1]} 项，共 ${total} 项`,
};

// 表格列宽配置
export const TABLE_COLUMN_WIDTHS = {
  ownerCode: 100,
  itemCode: 120,
  itemName: 200,
  englishName: 180,
  shortName: 120,
  stockUnit: 100,
  itemType: 120,
  status: 80,
  brandName: 120,
  group: 100,
  packaging: 100,
  price: 100,
  strategicFlag: 80,
  displayType: 100,
  firstReceivedTime: 160,
  selfBrandFlag: 80,
  gmtCreate: 160,
  gmtModified: 160,
  action: 80,
};

// 状态颜色配置
export const STATUS_COLORS = {
  'Active': 'green',
  'ACTIVE': 'green',
  'Deactivated': 'orange', 
  'INACTIVE': 'orange', 
  'Obsolete': 'red',
  'OBSOLETE': 'red',
};


export const HAS_EDIT_COLORS = {
  true: 'green',
  false: 'red',
};

// 搜索表单布局配置
export const SEARCH_FORM_LAYOUT = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

// 详情页面标签页配置
export const DETAIL_TABS = [
  {
    key: 'basic',
    label: '基本信息',
  },
  {
    key: 'physical',
    label: '物理特性',
  },
  {
    key: 'category',
    label: '类目信息',
  },
  {
    key: 'attributes',
    label: '商品特性',
  },
  {
    key: 'images',
    label: '商品图片',
  },
  {
    key: 'time',
    label: '时间信息',
  },
  {
    key: 'relations',
    label: '关联信息',
  },
];

// 详情信息描述配置
export const DESCRIPTION_CONFIG = {
  size: 'small' as const,
  column: 3,
  labelStyle: { 
    backgroundColor: '#fafafa',
    fontWeight: 500,
    width: '120px',
  },
};

// 导出文件名配置
export const EXPORT_CONFIG = {
  fileName: '商品主数据',
  fileExtension: '.xlsx',
  maxExportRows: 100000, // 最大导出行数
};

// 图片预览配置
export const IMAGE_PREVIEW_CONFIG = {
  width: 100,
  height: 100,
  objectFit: 'cover' as const,
  borderRadius: 4,
  cursor: 'pointer',
  border: '1px solid #d9d9d9',
};

// 筛选面板配置
export const FILTER_PANEL_CONFIG = {
  collapsed: false,
  collapsible: true,
  expandIconPosition: 'end' as const,
  size: 'small' as const,
};

// 表格配置
export const TABLE_CONFIG = {
  size: 'small' as const,
  bordered: false,
  showHeader: true,
  scroll: { x: 1500 },
  sticky: true,
  pagination: DEFAULT_PAGINATION,
};

// 字段长度限制
export const FIELD_LENGTH_LIMITS = {
  itemCode: 50,
  itemName: 200,
  englishName: 200,
  shortName: 100,
  brandCode: 50,
  brandName: 100,
  search: 100,
  remark: 500,
};

// 数字字段格式化配置
export const NUMBER_FORMAT_CONFIG = {
  price: {
    precision: 2,
    prefix: '￥',
  },
  weight: {
    precision: 4,
    suffix: 'kg',
  },
  dimension: {
    precision: 2,
    suffix: 'cm',
  },
  volume: {
    precision: 3,
    suffix: 'cm³',
  },
};

// 时间格式配置
export const TIME_FORMAT = {
  dateTime: 'YYYY-MM-DD HH:mm:ss',
  date: 'YYYY-MM-DD',
  time: 'HH:mm:ss',
};

// 表单验证规则
export const VALIDATION_RULES = {
  required: {
    required: true,
    message: '此字段为必填项',
  },
  itemCode: {
    pattern: /^[A-Z0-9]+$/,
    message: '商品编码只能包含大写字母和数字',
  },
  email: {
    type: 'email' as const,
    message: '请输入正确的邮箱格式',
  },
  number: {
    type: 'number' as const,
    message: '请输入有效的数字',
  },
  positiveNumber: {
    validator: (_: any, value: number) => {
      if (value && value <= 0) {
        return Promise.reject(new Error('请输入大于0的数字'));
      }
      return Promise.resolve();
    },
  },
};

// 操作按钮配置
export const ACTION_BUTTONS = {
  search: {
    type: 'primary' as const,
    htmlType: 'submit' as const,
    text: '搜索',
  },
  reset: {
    text: '重置',
  },
  export: {
    type: 'primary' as const,
    text: '导出',
  },
  refresh: {
    text: '刷新',
  },
  detail: {
    type: 'link' as const,
    text: '详情',
  },
};